import { Availability, AvailabilityService, CreateAvailability } from '@services';
import { message } from 'antd';
import { makeAutoObservable, runInAction } from 'mobx';

class AvailabilityStore {
  workAvailabilities = new Map<string, Availability>();
  dropoffAvailabilities = new Map<string, Availability>();
  loading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  getWorkAvailabilities = async () => {
    this.setLoading(true);
    try {
      const result = await AvailabilityService.getAvailabilities({ type: 'work' });
      result.forEach((item) => {
        this.workAvailabilities.set(item.id, item);
      });
    } catch (error) {
      console.error('Error fetching availability:', error);
    } finally {
      this.setLoading(false);
    }
  };

  getDropoffAvailabilities = async () => {
    this.setLoading(true);
    try {
      const result = await AvailabilityService.getAvailabilities({ type: 'dropoff' });
      result.forEach((item) => {
        this.dropoffAvailabilities.set(item.id, item);
      });
    } catch (error) {
      console.error('Error fetching availability:', error);
    } finally {
      this.setLoading(false);
    }
  };

  createOrUpdate = async (input: CreateAvailability[]) => {
    this.setLoading(true);
    try {
      await AvailabilityService.createOrUpdate(input);
      message.success({
        content: 'Successfully updated!',
      });
    } catch (error) {
      console.error('Error creating availability:', error);
    } finally {
      this.setLoading(false);
    }
  };

  setLoading = (value: boolean) => {
    runInAction(() => {
      this.loading = value;
    });
  };

  clearWorkAvailabilities = () => {
    runInAction(() => {
      this.workAvailabilities.clear();
    });
  };
  clearDropoffAvailabilities = () => {
    runInAction(() => {
      this.dropoffAvailabilities.clear();
    });
  };
}

export default AvailabilityStore;
